var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMobilemedium(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 13.68a.62.62 0 1 0 0-1.25.62.62 0 0 0 0 1.25ZM10.74 4.64H7.26c-.2 0-.36.15-.36.34v6.59c0 .19.16.34.36.34h3.48c.2 0 .36-.15.36-.34v-6.6a.35.35 0 0 0-.36-.33Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9 1a8 8 0 1 0 0 16A8 8 0 0 0 9 1Zm3.11 11.95c0 .6-.5 1.1-1.1 1.1H6.99c-.6 0-1.1-.5-1.1-1.1V5.02c0-.61.5-1.1 1.1-1.1h4.02c.6 0 1.1.49 1.1 1.1v7.93Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobilemedium);
export default __webpack_public_path__ + "static/media/mobile.medium.20122602d1a68faba5529a5b5a82e95a.svg";
export { ForwardRef as ReactComponent };